// Pays (français) + nationalité (gentilé) associés. Utilisé pour l'autocomplétion.
const DATA = [
  ["Afghanistan", "Afghane"], ["Afrique du Sud", "Sud-africaine"], ["Albanie", "Albanaise"],
  ["Algérie", "Algérienne"], ["Allemagne", "Allemande"], ["Andorre", "Andorrane"],
  ["Angola", "Angolaise"], ["Arabie saoudite", "Saoudienne"], ["Argentine", "Argentine"],
  ["Arménie", "Arménienne"], ["Australie", "Australienne"], ["Autriche", "Autrichienne"],
  ["Azerbaïdjan", "Azerbaïdjanaise"], ["Bahreïn", "Bahreïnienne"], ["Bangladesh", "Bangladaise"],
  ["Belgique", "Belge"], ["Bénin", "Béninoise"], ["Biélorussie", "Biélorusse"],
  ["Birmanie", "Birmane"], ["Bolivie", "Bolivienne"], ["Bosnie-Herzégovine", "Bosnienne"],
  ["Botswana", "Botswanaise"], ["Brésil", "Brésilienne"], ["Bulgarie", "Bulgare"],
  ["Burkina Faso", "Burkinabée"], ["Burundi", "Burundaise"], ["Cambodge", "Cambodgienne"],
  ["Cameroun", "Camerounaise"], ["Canada", "Canadienne"], ["Chili", "Chilienne"],
  ["Chine", "Chinoise"], ["Chypre", "Chypriote"], ["Colombie", "Colombienne"],
  ["Comores", "Comorienne"], ["Congo", "Congolaise"], ["Corée du Sud", "Sud-coréenne"],
  ["Corée du Nord", "Nord-coréenne"], ["Costa Rica", "Costaricaine"], ["Côte d'Ivoire", "Ivoirienne"],
  ["Croatie", "Croate"], ["Cuba", "Cubaine"], ["Danemark", "Danoise"],
  ["Djibouti", "Djiboutienne"], ["Égypte", "Égyptienne"], ["Émirats arabes unis", "Émirienne"],
  ["Équateur", "Équatorienne"], ["Espagne", "Espagnole"], ["Estonie", "Estonienne"],
  ["États-Unis", "Américaine"], ["Éthiopie", "Éthiopienne"], ["Finlande", "Finlandaise"],
  ["France", "Française"], ["Gabon", "Gabonaise"], ["Gambie", "Gambienne"],
  ["Géorgie", "Géorgienne"], ["Ghana", "Ghanéenne"], ["Grèce", "Grecque"],
  ["Guatemala", "Guatémaltèque"], ["Guinée", "Guinéenne"], ["Haïti", "Haïtienne"],
  ["Honduras", "Hondurienne"], ["Hongrie", "Hongroise"], ["Île Maurice", "Mauricienne"],
  ["Inde", "Indienne"], ["Indonésie", "Indonésienne"], ["Irak", "Irakienne"],
  ["Iran", "Iranienne"], ["Irlande", "Irlandaise"], ["Islande", "Islandaise"],
  ["Israël", "Israélienne"], ["Italie", "Italienne"], ["Jamaïque", "Jamaïcaine"],
  ["Japon", "Japonaise"], ["Jordanie", "Jordanienne"], ["Kazakhstan", "Kazakhe"],
  ["Kenya", "Kényane"], ["Koweït", "Koweïtienne"], ["Laos", "Laotienne"],
  ["Lettonie", "Lettone"], ["Liban", "Libanaise"], ["Liberia", "Libérienne"],
  ["Libye", "Libyenne"], ["Liechtenstein", "Liechtensteinoise"], ["Lituanie", "Lituanienne"],
  ["Luxembourg", "Luxembourgeoise"], ["Macédoine du Nord", "Macédonienne"], ["Madagascar", "Malgache"],
  ["Malaisie", "Malaisienne"], ["Malawi", "Malawienne"], ["Maldives", "Maldivienne"],
  ["Mali", "Malienne"], ["Malte", "Maltaise"], ["Maroc", "Marocaine"],
  ["Mauritanie", "Mauritanienne"], ["Mexique", "Mexicaine"], ["Moldavie", "Moldave"],
  ["Monaco", "Monégasque"], ["Mongolie", "Mongole"], ["Monténégro", "Monténégrine"],
  ["Mozambique", "Mozambicaine"], ["Namibie", "Namibienne"], ["Népal", "Népalaise"],
  ["Nicaragua", "Nicaraguayenne"], ["Niger", "Nigérienne"], ["Nigeria", "Nigériane"],
  ["Norvège", "Norvégienne"], ["Nouvelle-Zélande", "Néo-zélandaise"], ["Oman", "Omanaise"],
  ["Ouganda", "Ougandaise"], ["Ouzbékistan", "Ouzbèke"], ["Pakistan", "Pakistanaise"],
  ["Panama", "Panaméenne"], ["Paraguay", "Paraguayenne"], ["Pays-Bas", "Néerlandaise"],
  ["Pérou", "Péruvienne"], ["Philippines", "Philippine"], ["Pologne", "Polonaise"],
  ["Portugal", "Portugaise"], ["Qatar", "Qatarienne"], ["République dominicaine", "Dominicaine"],
  ["République tchèque", "Tchèque"], ["Roumanie", "Roumaine"], ["Royaume-Uni", "Britannique"],
  ["Russie", "Russe"], ["Rwanda", "Rwandaise"], ["Sénégal", "Sénégalaise"],
  ["Serbie", "Serbe"], ["Singapour", "Singapourienne"], ["Slovaquie", "Slovaque"],
  ["Slovénie", "Slovène"], ["Somalie", "Somalienne"], ["Soudan", "Soudanaise"],
  ["Sri Lanka", "Sri-lankaise"], ["Suède", "Suédoise"], ["Suisse", "Suisse"],
  ["Syrie", "Syrienne"], ["Tadjikistan", "Tadjike"], ["Tanzanie", "Tanzanienne"],
  ["Tchad", "Tchadienne"], ["Thaïlande", "Thaïlandaise"], ["Togo", "Togolaise"],
  ["Tunisie", "Tunisienne"], ["Turquie", "Turque"], ["Ukraine", "Ukrainienne"],
  ["Uruguay", "Uruguayenne"], ["Venezuela", "Vénézuélienne"], ["Vietnam", "Vietnamienne"],
  ["Yémen", "Yéménite"], ["Zambie", "Zambienne"], ["Zimbabwe", "Zimbabwéenne"],
];

export const COUNTRIES_FR = DATA.map((d) => d[0]);
export const NATIONALITIES_FR = Array.from(new Set(DATA.map((d) => d[1]))).sort((a, b) => a.localeCompare(b, "fr"));
